export function getParentPath(path: string) {
  let splitPath = path.split("/");
  if (splitPath.length === 1) return "";
  // remove fileName
  splitPath.pop();
  return splitPath.join("/");
}
